import styled from 'styled-components'

const CustomersIndexWrapper = styled.div`
  .dashboard-breadcrumb {
    font-size: 14px;
    color: ${(props) => props.theme.tokens.textMuted};
    margin-bottom: 16px;
  }

  .dashboard-breadcrumb .sep {
    margin: 0 8px;
    opacity: 0.6;
  }

  .dashboard-card {
    background: ${(props) => props.theme.tokens.surface};
    border-radius: 8px;
    padding: 24px;
  }

  .dashboard-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  .dashboard-title {
    font-size: 22px;
    font-weight: 600;
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  .dashboard-subtitle {
    font-size: 14px;
    color: ${(props) => props.theme.tokens.textMuted};
    margin-top: 2px;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
    margin-bottom: 20px;
  }

  .stat-tile {
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    border-radius: 8px;
    padding: 14px 16px;
  }

  .stat-label {
    font-size: 13px;
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .stat-value {
    font-size: 24px;
    font-weight: 600;
    margin-top: 2px;
    font-variant-numeric: tabular-nums;
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  .controls-row {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 20px;
  }

  .controls-row .search {
    flex: 1;
  }

  .list-section {
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    border-radius: 8px;
    overflow: hidden;
  }

  .section-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    padding: 12px 16px;
    background: ${(props) => props.theme.tokens.surfaceHover};
    border-bottom: 1px solid ${(props) => props.theme.tokens.borderSubtle};
  }

  .section-title {
    font-size: 15px;
    font-weight: 600;
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  .section-hint {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .groups {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .group-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;
    background: ${(props) => props.theme.tokens.surfaceHover};
    border-bottom: 1px solid ${(props) => props.theme.tokens.borderSubtle};
  }

  .group-count {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textMuted};
    background: ${(props) => props.theme.tokens.surface};
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    border-radius: 4px;
    padding: 0 6px;
    line-height: 20px;
  }

  .group-meta {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textMuted};
    margin-top: 2px;
  }

  .group-actions {
    display: flex;
    gap: 16px;
    white-space: nowrap;
    font-size: 14px;
    padding-top: 2px;
  }

  .projects-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    padding: 10px 16px;
    border-bottom: 1px solid ${(props) => props.theme.tokens.borderSubtle};
  }

  .projects-label {
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .project-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    border-radius: 6px;
    padding: 3px 10px;
    font-size: 12px;
  }

  .group-empty {
    padding: 12px 16px;
    font-size: 13px;
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .no-results {
    padding: 40px;
    text-align: center;
    font-size: 14px;
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .cell-secondary {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textSecondary};
  }

  .num {
    font-variant-numeric: tabular-nums;
  }

  .hl {
    background: rgba(250, 219, 20, 0.4);
    color: inherit;
    padding: 0 1px;
    border-radius: 2px;
  }
`

export default CustomersIndexWrapper
